import React from "react";
import SideLink from "./SideLink";
import classes from "./SideBar.module.css";
import img from "../assets/daniel.jpeg";

function SideBar() {
  return (
    <section className={classes.fixed}>
      <header className={classes.header}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          fill="currentColor"
          className="bi bi-twitter"
          viewBox="0 0 16 16"
          style={{ color: "#fff" }}
          id={classes.logo}
        >
          <path
            d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 
              0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 
              0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 
              0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 
              0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 
              .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"
          />
        </svg>
        <div
          style={{
            margin: "1rem 0",
          }}
        >
          <SideLink
            link="home"
            path="M 22.58 7.35 L 12.475 1.897 c -0.297 -0.16 -0.654 -0.16 -0.95 0 L 1.425 7.35 
            c -0.486 0.264 -0.667 0.87 -0.405 1.356 c 0.18 0.335 0.525 0.525 0.88 0.525 c 0.16 0 0.324 
            -0.038 0.475 -0.12 l 0.734 -0.396 l 1.59 11.25 c 0.216 1.214 1.31 2.062 2.66 2.062 h 9.282 
            c 1.35 0 2.444 -0.848 2.662 -2.088 l 1.588 -11.225 l 0.737 0.398 c 0.485 0.263 1.092 0.082
            1.354 -0.404 c 0.263 -0.486 0.08 -1.093 -0.404 -1.355 Z M 12 15.435 c -1.795 0 -3.25 -1.455 
            -3.25 -3.25 s 1.455 -3.25 3.25 -3.25 s 3.25 1.455 3.25 3.25 s -1.455 3.25 -3.25 3.25 Z"
          />
          <SideLink
            link="Explore"
            path="M 21 7.337 h -3.93 l 0.372 -4.272 c 0.036 -0.412 -0.27 -0.775
          -0.682 -0.812 c -0.417 -0.03 -0.776 0.27 -0.812 0.683 l -0.383 4.4
          h -6.32 l 0.37 -4.27 c 0.037 -0.413 -0.27 -0.776 -0.68 -0.813 c
          -0.42 -0.03 -0.777 0.27 -0.813 0.683 l -0.382 4.4 H 3.782 c -0.414
          0 -0.75 0.337 -0.75 0.75 s 0.336 0.75 0.75 0.75 H 7.61 l -0.55
          6.327 H 3 c -0.414 0 -0.75 0.336 -0.75 0.75 s 0.336 0.75 0.75 0.75
          h 3.93 l -0.372 4.272 c -0.036 0.412 0.27 0.775 0.682 0.812 l
          0.066 0.003 c 0.385 0 0.712 -0.295 0.746 -0.686 l 0.383 -4.4 h
          6.32 l -0.37 4.27 c -0.036 0.413 0.27 0.776 0.682 0.813 l 0.066
          0.003 c 0.385 0 0.712 -0.295 0.746 -0.686 l 0.382 -4.4 h 3.957 c
          0.413 0 0.75 -0.337 0.75 -0.75 s -0.337 -0.75 -0.75 -0.75 H 16.39
          l 0.55 -6.327 H 21 c 0.414 0 0.75 -0.336 0.75 -0.75 s -0.336 -0.75
          -0.75 -0.75 Z m -6.115 7.826 h -6.32 l 0.55 -6.326 h 6.32 l -0.55
          6.326 Z"
          />
          <SideLink
            link="communities"
            path="M 19.374 12.515 l -0.49 -0.38 c 0.95 -1.07 1.51 -2.48 1.51 -4 c 0 -3.36 -2.75 
          -6.11 -6.14 -6.11 c -1.18 0 -2.29 0.34 -3.22 0.91 c -0.81 -0.57 -1.78 -0.91 -2.84 -0.91 c -2.69 
          0 -4.88 2.18 -4.88 4.85 c 0 1.02 0.31 1.97 0.86 2.75 c -2 1.5 -3.2 3.86 -3.2 6.36 c 0 1.28 1.06 
          2.33 2.34 2.33 h 2.3 c -0.06 0.4 -0.09 0.81 -0.09 1.23 c 0 1.37 1.12 2.49 2.49 2.49 h 12.47 c 0.69 
          0 1.31 -0.28 1.76 -0.73 c 0.46 -0.45 0.73 -1.08 0.73 -1.77 c 0 -2.79 -1.35 -5.42 -3.6 -7.02 Z m -7.27 
          -8.53 c 0.65 -0.33 1.38 -0.52 2.15 -0.52 c 2.59 0 4.71 2.1 4.71 4.67 c 0 1.3 -0.54 2.48 -1.41 3.33 c 
          -0.26 0.25 -0.55 0.48 -0.85 0.65 h -0.01 c -0.19 0.12 -0.38 0.22 -0.58 0.3 c -0.41 0.19 -0.85 0.32 -1.3 
          0.36 c -0.04 0.01 -0.09 0.01 -0.13 0.01 c -0.14 0.02 -0.28 0.03 -0.43 0.03 c -0.31 0 -0.6 -0.03 -0.89 
          -0.08 c -0.67 -0.13 -1.28 -0.4 -1.82 -0.77 c -0.25 -0.17 -0.48 -0.37 -0.7 -0.59 c -0.08 -0.09 -0.17 -0.18 
          -0.24 -0.28 c -0.31 -0.37 -0.56 -0.79 -0.74 -1.24 c -0.21 -0.54 -0.33 -1.11 -0.33 -1.72 c 0 -1.29 0.54 
          -2.46 1.4 -3.32 c 0.35 -0.33 0.74 -0.62 1.17 -0.83 Z m -3.91 -0.52 c 0.6 0 1.16 0.15 1.65 0.42 c -1.08 
          1.1 -1.74 2.6 -1.74 4.25 c 0 0.75 0.13 1.47 0.39 2.14 c -0.1 0.02 -0.2 0.02 -0.3 0.02 c -0.65 0 -1.25
          -0.18 -1.76 -0.49 c -0.24 -0.14 -0.46 -0.31 -0.65 -0.5 c -0.18 -0.16 -0.33 -0.35 -0.46 -0.55 c -0.37 
          -0.54 -0.58 -1.19 -0.58 -1.88 c 0 -1.87 1.55 -3.41 3.45 -3.41 Z m -2.25 13.42 h -2.63 c -0.5 0 -0.9 -0.41 
          -0.9 -0.91 c 0 -2.1 1.02 -4.07 2.75 -5.3 c 0.84 0.66 1.88 1.05 3.03 1.05 c 0.35 0 0.69 -0.04 1.02 -0.11 
          c 0.11 0.18 0.26 0.35 0.4 0.52 l -0.41 0.32 c -1.56 1.1 -2.69 2.66 -3.26 4.43 Z m 14.54 3.72 H 8.014 c -0.58 
          0 -1.06 -0.48 -1.06 -1.07 c 0 -0.42 0.04 -0.82 0.11 -1.22 c 0.08 -0.5 0.22 -0.97 0.41 -1.43 c 0.51 -1.29 1.39 
          -2.44 2.57 -3.27 l 0.65 -0.5 c 1.01 0.72 2.24 1.14 3.56 1.14 c 0.34 0 0.68 -0.03 1 -0.09 c 0.49 -0.08 0.95 
          -0.21 1.39
            -0.39 c 0.41 -0.18 0.81 -0.4 1.17 -0.66 l 0.7 0.54 c 1.9 1.36 3.03 3.55 3.03 5.88 c 0 0.59 -0.47 1.07 -1.06 
            1.07 Z"
          />
          <SideLink
            link="notifications"
            path="M 21.697 16.468 c -0.02 -0.016 -2.14 -1.64 -2.103 -6.03 c 0.02 -2.532 -0.812 -4.782 
          -2.347 -6.335 C 15.872 2.71 14.01 1.94 12.005 1.93 h -0.013 c -2.004 0.01 -3.866 0.78 -5.242 2.174 c 
          -1.534 1.553 -2.368 3.802 -2.346 6.334 c 0.037 4.33 -2.02 5.967 -2.102 6.03 c -0.26 0.193 -0.366 0.53 
          -0.265 0.838 c 0.102 0.308 0.39 0.515 0.712 0.515 h 4.92 c 0.102 2.31 1.997 4.16 4.33 4.16 s 4.226 
          -1.85 4.327 -4.16 h 4.922 c 0.322 0 0.61 -0.206 0.71 -0.514 c 0.103 -0.307 -0.003 -0.645 -0.263 -0.838 
          Z M 12 20.478 c -1.505 0 -2.73 -1.177 -2.828 -2.658 h 5.656 c -0.1 1.48 -1.323 2.66 -2.828 2.66 Z M 4.38 
          16.32 c 0.74 -1.132 1.548 -3.028 1.524 -5.896 c -0.018 -2.16 0.644 -3.982 1.913 -5.267 C 8.91 4.05 10.397 
          3.437 12 3.43 c 1.603 0.008 3.087 0.62 4.18 1.728 c 1.27 1.285 1.933 3.106 1.915 5.267 c -0.024 2.868 0.785 
          4.765 1.525 5.896 H 4.38 Z"
          />
          <SideLink
            link="messages"
            path="M 19.25 3.018 H 4.75 C 3.233 3.018 2 4.252 2 5.77 v 12.495 c 0 1.518 1.233 2.753 2.75 
          2.753 h 14.5 c 1.517 0 2.75 -1.235 2.75 -2.753 V 5.77 c 0 -1.518 -1.233 -2.752 -2.75 -2.752 Z m -14.5 
          1.5 h 14.5 c 0.69 0 1.25 0.56 1.25 1.25 v 0.714 l -8.05 5.367 c -0.273 0.18 -0.626 0.182 -0.9 -0.002 L 
          3.5 6.482 v -0.714 c 0 -0.69 0.56 -1.25 1.25 -1.25 Z m 14.5 14.998 H 4.75 c -0.69 0 -1.25 -0.56 -1.25 
          -1.25 V 8.24 l 7.24 4.83 c 0.383 0.256 0.822 0.384 1.26 0.384 c 0.44 0 0.877 -0.128 1.26 -0.383 l 7.24 
          -4.83 v 10.022 c 0 0.69 -0.56 1.25 -1.25 1.25 Z"
          />
          <SideLink
            link="bookmarks"
            path="M 12 11.816 c 1.355 0 2.872 -0.15 3.84 -1.256 c 0.814 -0.93 1.078 -2.368 0.806 -4.392 
          c -0.38 -2.825 -2.117 -4.512 -4.646 -4.512 S 7.734 3.343 7.354 6.17 c -0.272 2.022 -0.008 3.46 
          0.806 4.39 c 0.968 1.107 2.485 1.256 3.84 1.256 Z M 8.84 6.368 c 0.162 -1.2 0.787 -3.212 3.16 
          -3.212 s 2.998 2.013 3.16 3.212 c 0.207 1.55 0.057 2.627 -0.45 3.205 c -0.455 0.52 -1.266 0.743 
          -2.71 0.743 s -2.255 -0.223 -2.71 -0.743 c -0.507 -0.578 -0.657 -1.656 -0.45 -3.205 Z m 11.44 12.868 
          c -0.877 -3.526 -4.282 -5.99 -8.28 -5.99 s -7.403 2.464 -8.28 5.99 c -0.172 0.692 -0.028 1.4 0.395 1.94 
          c 0.408 0.52 1.04 0.82 1.733 0.82 h 12.304 c 0.693 0 1.325 -0.3 1.733 -0.82 c 0.424 -0.54 0.567 -1.247 
          0.394 -1.94 Z m -1.576 1.016 c -0.126 0.16 -0.316 0.246 -0.552 0.246 H 5.848 c -0.235 0 -0.426 -0.085 
          -0.552 -0.246 c -0.137 -0.174 -0.18 -0.412 -0.12 -0.654 c 0.71 -2.855 3.517 -4.85 6.824 -4.85 s 6.114 
          1.994 6.824 4.85 c 0.06 0.242 0.017 0.48 -0.12 0.654 Z"
          />
          <SideLink
            link="more"
            circle1="17"
            circle2="12"
            circle12="12"
            circle7="7"
            circle3="1.5"
            path="M 12 22.75 C 6.072 22.75 1.25 17.928 1.25 12 S 6.072 1.25 12 1.25 S 22.75 6.072 22.75 12 S 17.928 22.75 12 22.75 Z m 0 -20 C 6.9 2.75 2.75 6.9 2.75 12 S 6.9 21.25 12 21.25 s 9.25 -4.15 9.25 -9.25 S 17.1 2.75 12 2.75 Z"
          />
        </div>

        <button id={classes.button}>Tweet</button>
      </header>

      {/* profile-box */}
      <a href="/" id={classes.container}>
        <div className={classes.profile}>
          <img
            src={img}
            alt="username"
            width="40"
            style={{ borderRadius: "50%" }}
          />
          <div className={classes.names}>
            <div className="name">Olowoniyi Daniel</div>
            <div
              className="username"
              style={{ color: "grey", fontSize: "14px" }}
            >
              iamdanztee
            </div>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="16"
            fill="currentColor"
            className="bi bi-three-dots"
            viewBox="0 0 16 16"
          >
            <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
          </svg>
        </div>
      </a>
    </section>
  );
}

export default SideBar;
